import { render, staticRenderFns } from "./EmailsDialog.vue?vue&type=template&id=0ddd53ec&scoped=true"
import script from "./EmailsDialog.vue?vue&type=script&lang=js"
export * from "./EmailsDialog.vue?vue&type=script&lang=js"
import style0 from "./EmailsDialog.vue?vue&type=style&index=0&id=0ddd53ec&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddd53ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ddd53ec')) {
      api.createRecord('0ddd53ec', component.options)
    } else {
      api.reload('0ddd53ec', component.options)
    }
    module.hot.accept("./EmailsDialog.vue?vue&type=template&id=0ddd53ec&scoped=true", function () {
      api.rerender('0ddd53ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bill/components/EmailsDialog.vue"
export default component.exports